import axios from "axios";
import {getEndpoints} from "../utils/server-endpoints";

export function prepareAuthHeader(token) {
    return {Authorization: `Bearer ${token}`}
}

async function sendCall(url, method, data, headers = {}) {
    let resp = await axios({url, method, data, headers})
    return resp.data
}

export async function sessionValid(token) {
    try {
        const {url, method} = getEndpoints().checkSession
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, {}, headers)
        return Promise.resolve(data.content)
    } catch (error) {
        return Promise.resolve({})
    }
}

export async function sendLoginRequest(body) {
    const {url, method} = getEndpoints().login
    try {
        let data = await sendCall(url, method, body)
        return data.content
    } catch (error) {
        console.error(error)
        return Promise.reject("invalid credentials")
    }
}

export async function sendRegisterRequest(body) {
    try {
        const {url, method} = getEndpoints().register
        let resp = await sendCall(url, method, body)
        return Promise.resolve(resp.content)
    } catch (error) {
        console.error(error)
        return Promise.reject("server error occurred")
    }
}

export async function checkUsernameDuplication(username) {
    try {
        const {url, method} = getEndpoints().checkUsernameDuplication
        const data = await sendCall(url, method, {username})
        return data.content
    } catch (error) {
        console.error(error)
        return Promise.reject("server error occurred")
    }
}

export async function logoutCall(token) {
    try {
        const {url, method} = getEndpoints().logout
        const headers = prepareAuthHeader(token)
        await sendCall(url, method, {}, headers)
        return true
    } catch (error) {
        console.error(error)
        return Promise.reject("server error occurred")
    }
}

export async function listing(token, body) {
    try {
        const {url, method} = getEndpoints().emailListing
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (error) {
        console.error(error)
        return Promise.reject(error.message)
    }
}

export async function listBoxes(token) {
    try {
        const {url, method} = getEndpoints().boxesListing
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, {}, headers)
        return data.content
    } catch (error) {
        console.error(error)
        return Promise.reject(error.message)
    }
}

export async function listEditableBoxes(token, body) {
    try {
        const {url, method} = getEndpoints().editableBoxesListing
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (error) {
        console.error(error)
        return Promise.reject(error.message)
    }
}

export async function addABoxOnServer(token, body) {
    try {
        console.log(body)
        const {url, method} = getEndpoints().addBox
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (error) {
        console.error(error)
        return Promise.reject(error)
    }
}

export async function deleteABoxFromServer(token, body) {
    try {
        console.log(body)
        const {url, method} = getEndpoints().deleteBox
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (error) {
        console.error(error)
        return Promise.reject(error.message)
    }
}

export async function fetchHeadersOfMessage(token, body) {
    try {
        const {url, method} = getEndpoints().fetchHeadersOfMessage
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (error) {
        console.error(error)
        return Promise.reject(error.message)
    }
}

export async function listUserBoxes(token) {
    try {
        const {url, method} = getEndpoints().userBoxesListing
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, {}, headers)
        return data.content
    } catch (error) {
        console.error(error)
        return Promise.reject(error.message)
    }
}

export async function sendMessageToBackend(body, token) {
    try {
        try {
            const {url, method} = getEndpoints().sendMessageHttp
            const headers = prepareAuthHeader(token)
            let data = await sendCall(url, method, body, headers)
            return data.content
        } catch (error) {
            console.error(error)
            return Promise.reject(error.message)
        }
    } catch (e) {

    }
}

export async function fetchPublicKeys(receivers, token) {
    try {
        const {url, method} = getEndpoints().fetchReceiversPublicKeys
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, {receivers}, headers)
        return data.content
    } catch (error) {
        console.error(error)
        return Promise.reject(error.message)
    }
}

export async function fetchMessageBody(uid, box, token) {
    try {
        const {url, method} = getEndpoints().fetchMessageBodyForRender
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, {uid, box}, headers)
        return data.content
    } catch (error) {
        console.error(error)
        return Promise.reject(error.message)
    }
}

export async function fetchAttachmentData(token, body) {
    try {
        const {url, method} = getEndpoints().fetchAttachmentData
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (error) {
        console.error(error)
        return Promise.reject(error.message)
    }
}

export async function listingForCache(body, token) {
    try {
        const {url, method} = getEndpoints().listingForCache
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (error) {
        console.error(error)
        return Promise.reject("Server error occurred.")
    }
}

export async function listingForBoxMove(body, token) {
    try {
        const {url, method} = getEndpoints().listingForBoxMove
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (error) {
        console.error(error)
        return Promise.reject("Server error occurred.")
    }
}

export async function getMessagesCount(token) {
    try {
        const {url, method} = getEndpoints().getMessagesCount
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, {}, headers)
        return data.content
    } catch (error) {
        console.error(error)
        return Promise.reject("Server error occurred.")
    }
}

export async function findMainAccountByExtAccount(token) {
    try {
        const {url, method} = getEndpoints().findMainAccountByExtAccount
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, {}, headers)
        return data.content
    } catch (error) {
        console.error(error)
        return Promise.reject("Server error occurred.")
    }
}

export async function findChangeOwnershipRequest(body, token) {
    try {
        const {url, method} = getEndpoints().findExistingChangeOwnershipRequest
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (error) {
        console.error(error)
        return Promise.reject("Server error occurred.")
    }
}

export async function startChangeOwnershipProgress(body, token) {
    try {
        const {url, method} = getEndpoints().startChangeOwnershipProgress
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (error) {
        console.error(error)
        return Promise.reject("Server error occurred.")
    }
}

export async function markMessageAsReadBackend(token, body) {
    try {
        const {url, method} = getEndpoints().markMessageAsRead
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (error) {
        console.error(error)
        return Promise.reject("Server error occurred.")
    }
}


export async function fetchThreadByThreadId(token, body) {
    try {
        const {url, method} = getEndpoints().fetchThreadByThreadId
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (error) {
        console.error(error)
        return Promise.reject("Server error occurred.")
    }
}

export async function deleteMessageOnServer(token, body) {
    try {
        const {url, method} = getEndpoints().deleteMessage
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.reject("Server error occurred.")
    }
}

export async function copyMessageOnServer(token, body) {
    try {
        const {url, method} = getEndpoints().copyMessage
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.reject("Server error occurred.")
    }
}

export async function moveMessageOnServer(token, body) {
    try {
        const {url, method} = getEndpoints().moveMessage
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.reject("Server error occurred.")
    }
}

export async function markMessageOnServer(token, body) {
    try {
        const {url, method} = getEndpoints().markMessage
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.reject("Server error occurred.")
    }
}

export async function addDomain(token, body) {
    try {
        const {url, method} = getEndpoints().addDomain
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.reject(e)
    }
}

export async function listDomains(token, body) {
    try {
        const {url, method} = getEndpoints().listDomains
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.reject("Server error occurred.")
    }
}


export async function deleteDomainOnServer(token, body) {
    try {
        const {url, method} = getEndpoints().deleteDomain
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.reject("Server error occurred.")
    }
}

export async function updateDomainOnServer(token, body) {
    try {
        const {url, method} = getEndpoints().updateDomain
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.reject(e)
    }
}

export async function listAliases(token, body) {
    try {
        const {url, method} = getEndpoints().listAliases
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.reject("Server error occurred.")
    }
}

export async function listAliasesAndDomains(token, body) {
    try {
        const {url, method} = getEndpoints().listAliasesAndDomains
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.reject("Server error occurred.")
    }
}

export async function addAliasOnServer(token, body) {
    try {
        const {url, method} = getEndpoints().addAlias
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.reject("Server error occurred.")
    }
}

export async function deleteAliasOnServer(token, body) {
    try {
        const {url, method} = getEndpoints().deleteAlias
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.reject("Server error occurred.")
    }
}

export async function fetchUserAccounts(token) {
    try {
        const {url, method} = getEndpoints().fetchUserAccounts
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, {}, headers)
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.resolve()
    }
}

export async function fetchGmailSyncProgress(token) {
    try {
        const {url, method} = getEndpoints().existingGmailProgress
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, {}, headers)
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.resolve()
    }
}

export async function startGmailSyncProcess(token, body) {
    try {
        const {url, method} = getEndpoints().startGmailSync
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.resolve()
    }
}

export async function resumeGmailSyncProcess(token, body) {
    try {
        const {url, method} = getEndpoints().resumeGmailSync
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.resolve()
    }
}

export async function cancelGmailSyncProcess(token) {
    try {
        const {url, method} = getEndpoints().cancelGmailSync
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, {}, headers)
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.resolve()
    }
}

export async function pauseGmailSyncProcess(token) {
    try {
        const {url, method} = getEndpoints().pauseGmailSync
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, {}, headers)
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.resolve()
    }
}

export async function findExternalReceivers(token, body) {
    try {
        const {url, method} = getEndpoints().findExternalReceivers
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.resolve()
    }
}

export async function registerExternalUsers(token, body) {
    try {
        const {url, method} = getEndpoints().registerExternalAccounts
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.resolve()
    }
}

export async function addUpdateUserEmailFilters(token, body) {
    try {
        const {url, method} = getEndpoints().addUpdateUserFilters
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.resolve()
    }
}

export async function deleteUserEmailFilters(token) {
    try {
        const {url, method} = getEndpoints().deleteUserFilters
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, {}, headers)
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.resolve()
    }
}

export async function fetchEmailFiltersLookupData(token) {
    try {
        const {url, method} = getEndpoints().emailFiltersLookup
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, {}, headers)
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.resolve()
    }
}

export async function lookupCall(token) {
    try {
        const {url, method} = getEndpoints().lookup
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, {}, headers)
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.resolve()
    }
}

export async function completeFiltersExecution(body, token) {
    try {
        const {url, method} = getEndpoints().completeFilterExecution
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.resolve()
    }
}

export async function savePasswordRecovery(body, token) {
    try {
        const {url, method} = getEndpoints().savePasswordRecovery
        const headers = prepareAuthHeader(token)
        let data = await sendCall(url, method, body, headers)
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.resolve()
    }
}

export async function fetchPasswordRecovery(body) {
    try {
        const {url, method} = getEndpoints().fetchPasswordRecovery
        let data = await sendCall(url, method, body)
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.resolve()
    }
}

export async function calculateBoxDownloadSize(boxName, token) {
    try {
        let {url, method} = getEndpoints().boxDownloadSize
        url = url.replace("BOX_NAME_HERE", boxName)
        let data = await sendCall(url, method, {}, prepareAuthHeader(token))
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.resolve()
    }
}

export async function adjustLoginForUser(body, token) {
    try {
        let {url, method} = getEndpoints().adjustLoginOfUser
        let data = await sendCall(url, method, body, prepareAuthHeader(token))
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.resolve()
    }
}

export async function fetchExistingReEncryptionProgress(token) {
    try {
        let {url, method} = getEndpoints().fetchExistingReEncryptionProgress
        let data = await sendCall(url, method, {}, prepareAuthHeader(token))
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.resolve()
    }
}

export async function checkDnsOfDomainFromServer(token, body) {
    try {
        let {url, method} = getEndpoints().checkDomainDns
        let data = await sendCall(url, method, body, prepareAuthHeader(token))
        return data.content
    } catch (e) {
        console.error(e)
        return Promise.reject(e)
    }
}